import React, { Fragment, useRef, useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import "../App.css";
import { useParams, useNavigate } from "react-router-dom";
import ProductModal from "../components/Modals/ProductModal";
import useMenuTranslate from "../hooks/useMenuTranslate";
import {
  ShopOutlined,
  StarOutlined,
  StarFilled,
  LoadingOutlined,
  InfoCircleOutlined,
  RightOutlined,
} from "@ant-design/icons";
import Nav from "../components/Nav/Nav";
import { LazyLoadImage } from "react-lazy-load-image-component";
import google from "../img/google.PNG";
import instagram from "../img/insta.png";
import tiktok from "../img/tiktok-logo.png";
import logo from "../img/logo.png";
import '../style/Translate.css';

import vegi from "../img/vegi.png";
import halal from "../img/halal.png";
import { logEvent } from "firebase/analytics";
import { analytics } from "../Firebase";
import CartBar from "../components/CartBar";
import CartModal from "../components/Modals/CartModal";
import AuthModal from "../components/Modals/AuthModal";
import { useTranslation } from "../i18n/useTranslation";
import PaymentModal from "../components/Modals/PaymentModal";

function Menu() {
  const navigate = useNavigate();
  const {
    getRestaurant,
    currentRestaurant,
    listProducts,
    getProducts,
    getCategories,
    listCategories,
    language,
    isProducts,
    basket,
    userProfile,
    userProfileLoading,
    isProfileComplete,
    clearBasket,
  } = useAuth();

  const { id } = useParams();
  const refs = useRef([]);
  const refList = useRef([]);
  const browserLanguage =
  navigator.language || navigator.userLanguage || "fr";

const isBrowserFrench = browserLanguage.toLowerCase().startsWith("fr");
const showTranslateButton = currentRestaurant?.international === true || !isBrowserFrench;
useMenuTranslate(showTranslateButton);
  const [scrollTop, setScrollTop] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isTimeout, setIsTimeout] = useState(false);
  const [currentList, setCurrentList] = useState(-1);
  const [currentMenu, setCurrentMenu] = useState(-1);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isAuthOpen, setIsAuthOpen] = useState(false);

  const { t } = useTranslation();

  const myCategories = (listCategories || []).filter(
    (categorie) => categorie.restaurant === id && categorie.status === "visible"
  );

  const myProducts = (listProducts || []).filter(
    (product) => product.restaurant === id && product.status === "visible"
  );

  useEffect(() => {
    getRestaurant(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (currentRestaurant) {
      getCategories(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRestaurant, id]);

  useEffect(() => {
    if (currentRestaurant) {
      getProducts(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRestaurant, id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTimeout(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isTimeout && !isProducts) {
      window.location.reload();
    }
  }, [isTimeout, isProducts]);

  useEffect(() => {
    if (basket?.length > 0) {
      const basketRestaurantId = basket[0]?.restaurantId;
  
      if (basketRestaurantId && basketRestaurantId !== id) {
        clearBasket();
        setIsCartOpen(false);
        setIsPaymentOpen(false);
        setIsOpen(false);
      }
    }
  }, [id, basket, clearBasket]);


  useEffect(() => {
    if (selectedProduct) {
      setIsOpen(true);
    }
  }, [selectedProduct]);

  const onPressStart = (index) => {
    if (!refs.current[index]) return;

    refs.current[index].scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "center",
    });
  };

  const listFn = (index) => {
    setCurrentList(index);
    setTimeout(onPressStart, 1000, index);

    if (!refList.current[index]) return;

    refList.current[index].scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  };

  const dots = (text, number) => {
    const basic = "No translation available";
    if (!text) return basic;

    const words = text.split(" ");
    if (words.length > number) {
      const truncatedText = words.slice(0, number).join(" ");
      return `${truncatedText}...`;
    }
    return text;
  };

  const bgC = (index) => {
    if (currentMenu === index) return "3px solid";
    if (currentList === index && currentMenu === index) return "3px solid";
    return undefined;
  };

  const handleProductClick = (product) => {
    logEvent(analytics, "product_view", {
      product_name: product.name,
      product_id: product.id,
      category: product.category,
      price: product.price,
    });
    setSelectedProduct(product);
    setIsOpen(true);
  };

  const handleValidateBasket = () => {
    if (currentRestaurant?.isOpen === false) {
      alert("Le restaurant est actuellement fermé");
      return;
    }
  
    setIsCartOpen(false);
  
    if (userProfileLoading) {
      setIsCartOpen(true);
      return;
    }
  
    if (isProfileComplete(userProfile)) {
      setIsPaymentOpen(true);
      return;
    }
  
    setIsAuthOpen(true);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    console.log("Basket:", basket);
  }, [basket]);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    document.body.style.overflow = "unset";

    refList.current.forEach((element, index) => {
      if (!element) return;

      const position = element.getBoundingClientRect();
      if (position.top > -(position.height / 2) && position.top < 0.3) {
        setCurrentMenu(index);
        setTimeout(onPressStart, 1000, index);
      }
    });
  }, [scrollTop]);

 
  return (
    <div className="menu-wrapper">
      <div className="menu-container2">
      <Nav menu onOpenAuth={() => setIsAuthOpen(true)} />
      {showTranslateButton && <div className="gtranslate_wrapper"></div>}
                    <div className="menu-filter">
          <LazyLoadImage
            fetchpriority="low"
            rel="preload"
            className="img-container"
            src={listProducts && currentRestaurant?.photo ? currentRestaurant.photo : ""}
            alt=""
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>

        {listProducts ? (
          <>
            <div className="menu-title">
              <div className="menu-title-container">
                <p translate="no" className="menu-title-text">{currentRestaurant?.name}</p>

                <div className="menu-links">
                  {currentRestaurant?.social?.google?.length > 0 && (
                    <a
                      className="link-social-container"
                      href={currentRestaurant.social.google}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img className="link-social" src={google} alt="Logo" />
                    </a>
                  )}

                  {currentRestaurant?.social?.instagram?.length > 0 && (
                    <a
                      className="link-social-container"
                      href={currentRestaurant.social.instagram}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img className="link-social tiktok" src={instagram} alt="Logo" />
                    </a>
                  )}

                  {currentRestaurant?.social?.tiktok?.length > 0 && (
                    <a
                      className="link-social-container"
                      href={currentRestaurant.social.tiktok}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img className="link-social insta" src={tiktok} alt="Logo" />
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div className="sub-menu-container">
            <div className="sub-menu-title">
  <ShopOutlined />{" "}
  {language
    ? currentRestaurant?.translated?.[language] || currentRestaurant?.type
    : currentRestaurant?.type}

  <br />

  {currentRestaurant?.paymentEnabled && currentRestaurant?.productType !== "digital" &&  (
  <div>
    <InfoCircleOutlined className="top-5" />{" "}

    {currentRestaurant?.productType === "digital" ? (
      <>
        {currentRestaurant?.minOrderPrice > 0
          ? `${Number(currentRestaurant.minOrderPrice).toFixed(2)} € min`
          : ""}
      </>
    ) : (
      <>
        {currentRestaurant?.deliveryEnabled && (
          <>
            Livré en {currentRestaurant?.preparationTime || 0}
            {currentRestaurant?.deliveryTimeUnit === "hours" ? "h" : " min"}
            {currentRestaurant?.minOrderPrice > 0
              ? ` · ${Number(currentRestaurant.minOrderPrice).toFixed(2)} € min`
              : ""}
            {" · "}
            frais de livraison :{" "}
            {Number(currentRestaurant?.deliveryFee || 0).toFixed(2)} €
          </>
        )}
      </>
    )}
  </div>
)}

  {currentRestaurant?.productType !== "digital"  && <div className="open-restaurant">
    {currentRestaurant?.isOpen ? "Ouvert" : "Fermé"}
  </div>}
</div>

              {currentRestaurant?.review && currentRestaurant.review !== "none" && (
                <button className="button save more-option menu-review-header" type="button">
                  <StarFilled />{" "}
                  {currentRestaurant.review === "demo" ? (
                    <span
                      style={{ color: "inherit" }}
                      onClick={() => alert("Indisponible en mode démo")}
                    >
                      {t("leave_review")}
                    </span>
                  ) : (
                    <a
                      href={currentRestaurant.review}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "inherit" }}
                    >
                      {t("leave_review")}
                    </a>
                  )}
                </button>
              )}
            </div>
          </>
        ) : (
          <div className="loading-menu">
            <LoadingOutlined spin />
          </div>
        )}

        {listProducts && (
          <div className="nav">
            {myCategories.map((category, index) => (
              <div
                key={index}
                ref={(element) => {
                  refs.current[index] = element;
                }}
                onClick={() => listFn(index)}
                className="menu-container"
                style={{ borderBottom: bgC(index) }}
              >
                <div className="menu-text">
                  {language
                    ? category?.translated?.[language] || category.name
                    : category.name}
                </div>
              </div>
            ))}
          </div>
        )}

        <CartBar onOpen={() => setIsCartOpen(true)} />

        {isCartOpen && (
          <CartModal
            setIsOpen={setIsCartOpen}
            onValidate={handleValidateBasket}
          />
        )}

{isAuthOpen && (
  <AuthModal
    setIsOpen={setIsAuthOpen}
    onSuccess={() => {
      setIsAuthOpen(false);

      if (basket?.length > 0) {
        setIsPaymentOpen(true);
      }
    }}
  />
)}

        {isPaymentOpen && (
          <PaymentModal
            setIsOpen={setIsPaymentOpen}
            onBack={() => {
              setIsPaymentOpen(false);
              setIsCartOpen(true);
            }}
            onPay={(paymentIntent) => {
              clearBasket();
              setIsPaymentOpen(false);
              navigate(`/orders/${paymentIntent.id}`);
            }}
          />
        )}

        {isOpen && selectedProduct && (
          <ProductModal
            name={selectedProduct.name}
            id={selectedProduct.id}
            price={selectedProduct.price}
            photos={selectedProduct.pictures?.length ? selectedProduct.pictures : (selectedProduct.picture ? [selectedProduct.picture] : [])}
            quantity={selectedProduct.quantity} 
            translatedOpt={selectedProduct.translatedOpt}
            description={
              language && selectedProduct?.translated?.[language]
                ? selectedProduct.translated[language]
                : selectedProduct.description
            }
            setIsOpen={setIsOpen}
            allergens={
              language &&
              selectedProduct?.allergens &&
              selectedProduct?.translated2?.[language]
                ? selectedProduct.translated2[language]
                : selectedProduct.allergens
            }
            label={selectedProduct?.label}
          />
        )}

        {listProducts && (
          <div className="product-wrapper">
            {myCategories.map((category, index) => (
              <div
                key={index}
                ref={(element) => {
                  refList.current[index] = element;
                }}
                className="product-container"
              >
                <div className="category-title">
                  {language
                    ? category?.translated?.[language] || category.name
                    : category.name}
                </div>

                {myProducts.map((product, index) => {
  const displayPrice =
    product?.translatedOpt?.length > 0 &&
    product.translatedOpt[0]?.type === "1"
      ? parseFloat(product.translatedOpt[0]?.price || 0).toFixed(2)
      : parseFloat(product.price || 0).toFixed(2);

  return (
    <Fragment key={index}>
      {category.id === product.category && (
        <div
          className="product"
          onClick={() => handleProductClick(product)}
        >
          <div className={`product-text-container ${!product.picture && "noMWidth"}`}>
            <p>
              {product.name}{" "}
              {product?.label && (
                <span>
                  <img
                    className="label-title"
                    src={product.label === "halal" ? halal : vegi}
                    alt="logo"
                  />
                </span>
              )}
            </p>

            {product.description !== product.name && (
              <p className="product-desc-text">
                {dots(
                  language
                    ? product?.translated?.[language] || product.description
                    : product.description,
                  !product.picture ? 14 : 10
                )}
              </p>
            )}

            {product.description === product.name && language && (
              <p className="product-desc-text">
                {dots(
                  language
                    ? product?.translated?.[language] || product.description
                    : product.description,
                  !product.picture ? 14 : 10
                )}
              </p>
            )}

            {product?.translatedOpt?.length === 0 && (
              <p className="product-price-text">
                {displayPrice} €{" "}
                {product?.allergens && (
                  <span className="allergen">{t("allergens")}</span>
                )}
              </p>
            )}

            {product?.translatedOpt?.length > 0 &&
              product.translatedOpt[0]?.type === "2" && (
                <p className="product-price-text">
                  {displayPrice} €{" "}
                  <RightOutlined className="more-option-price" />{" "}
                  {product?.allergens && (
                    <span className="allergen">{t("allergens")}</span>
                  )}
                </p>
              )}

            {product?.translatedOpt?.length > 0 &&
              product.translatedOpt[0]?.type === "1" && (
                <p className="product-price-text">
                  {displayPrice} €{" "}
                  <RightOutlined className="more-option-price" />{" "}
                  {product?.allergens && (
                    <span className="allergen">{t("allergens")}</span>
                  )}
                </p>
              )}

            {!product?.translatedOpt && (
              <p className="product-price-text">
                {displayPrice} €{" "}
                {product?.allergens && (
                  <span className="allergen">{t("allergens")}</span>
                )}
              </p>
            )}
          </div>

          {product.picture && (
            <div>
              <img
                fetchpriority="low"
                className="img-product-container"
                alt=""
                src={product.picture}
              />
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
})}
              </div>
            ))}
          </div>
        )}

        {listProducts && currentRestaurant?.review && currentRestaurant.review !== "none" &&
          <div className="review-wrapper">
            {currentRestaurant?.logo && (
              <div className="bottom-logo-container">
                <img className="bottom-logo" src={currentRestaurant.logo} alt="Logo" />
              </div>
            )}

            <p className="review-title">{t("leave_review")}</p>
            <p className="review-text">{t("experience")}</p>

            {currentRestaurant?.review === "demo" ? (
              <p
                className="review-icons"
                onClick={() => alert("Indisponible en mode démo")}
              >
                <StarOutlined />
                <StarOutlined />
                <StarOutlined />
                <StarOutlined />
                <StarOutlined />
              </p>
            ) : (
              <a
                href={currentRestaurant?.review}
                target="_blank"
                rel="noreferrer"
                className="review-icons"
              >
                <StarOutlined />
                <StarOutlined />
                <StarOutlined />
                <StarOutlined />
                <StarOutlined />
              </a>
            )}

<div className="block-logo-bottom ">
          <p className="review-text review-text-b" >Proposé par </p>
         
           <img className="logo-bottom" onClick={() => navigate(`/`)}  src={logo} alt="/" />
          </div>
          
          </div>} 

          { listProducts && currentRestaurant?.logo &&
            <div className="bottom-logo-container no-review">
            { currentRestaurant?.logo && <img className="bottom-logo" src={currentRestaurant?.logo} alt="Logo" />}
            </div>
          }

          { listProducts && currentRestaurant?.logo &&
            <div className="bottom-logo-container no-review">
            { currentRestaurant?.logo && <img className="bottom-logo" src={currentRestaurant?.logo} alt="Logo" />}
            </div>
          }

          { listProducts && !currentRestaurant?.review && <div className="review-wrapper">

            <div className="block-logo-bottom ">
          <p className="review-text review-text-b" >Proposé par </p>
         
           <img className="logo-bottom" onClick={() => navigate(`/`)}  src={logo} alt="/" />
          </div>
          

          </div>

          }


      </div>
    </div>
  );
}

export default Menu;